/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventModel } from './EventModel';
import {
    EventModelFromJSON,
    EventModelFromJSONTyped,
    EventModelToJSON,
} from './EventModel';

/**
 * 
 * @export
 * @interface FormFieldCollapsibleModel
 */
export interface FormFieldCollapsibleModel {
    /**
     * Indicates to the client the FormField is collapsed (or not).
     * @type {boolean}
     * @memberof FormFieldCollapsibleModel
     */
    isCollapsed: boolean;
    /**
     * This is the message that is displayed to the customer if isCollapsed=true.
     * @type {string}
     * @memberof FormFieldCollapsibleModel
     */
    message: string;
    /**
     * 
     * @type {EventModel}
     * @memberof FormFieldCollapsibleModel
     */
    event?: EventModel;
}

/**
 * Check if a given object implements the FormFieldCollapsibleModel interface.
 */
export function instanceOfFormFieldCollapsibleModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "isCollapsed" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function FormFieldCollapsibleModelFromJSON(json: any): FormFieldCollapsibleModel {
    return FormFieldCollapsibleModelFromJSONTyped(json, false);
}

export function FormFieldCollapsibleModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormFieldCollapsibleModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isCollapsed': json['isCollapsed'],
        'message': json['message'],
        'event': !exists(json, 'event') ? undefined : EventModelFromJSON(json['event']),
    };
}

export function FormFieldCollapsibleModelToJSON(value?: FormFieldCollapsibleModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isCollapsed': value.isCollapsed,
        'message': value.message,
        'event': EventModelToJSON(value.event),
    };
}

